import { Theme } from "@amx/ux-twoui-theming";
import { IStackStyles } from "@fluentui/react";
import { ChevronPosition } from "./DrawerHeaderChevron/DrawerHeaderChevron";

export const getDrawerHeaderWrapperStyles = (theme: Theme, showAltBackgroundColor: boolean, minHeight?: string): IStackStyles => ({
    root: {
        minHeight,
        width: "100%",
        backgroundColor: showAltBackgroundColor ? theme.palette.neutralMed : theme.palette.neutralHigh,
        textAlign: "left",
        selectors: {
            ":hover": {
                backgroundColor: theme.palette.neutralLighter
            },
            ":active": {
                backgroundColor: theme.palette.neutralLight
            }
        }
    }
});

export const getDrawerHeaderColumnsStyles = (): IStackStyles => {

    return {
        root: {
            width: "100%"
        }
    };
};

export const getDrawerHeaderChevronStyles = (): IStackStyles => {

    return {
        root: {
            padding: "0px 16px"
        }
    };
};

export const getDrawerHeaderChevronSlotStyles = (isChevronSlot: boolean): IStackStyles => {

    return {
        root: {
            width: isChevronSlot ? "calc(100% - 48px)" : "100%"
        }
    };
};

export const getDrawerHeaderEndSlotStyles = (chevronPosition: ChevronPosition, indentPadding: string): IStackStyles => {
    // tslint:disable-next-line: no-magic-numbers
    const paddingStart = indentPadding !== "0px" ? `calc(${indentPadding} + 8px)` : "8px";
    const paddingEnd = indentPadding !== "0px" ? `calc(${indentPadding} + 16px)` : "16px";

    return {
        root: {
            padding: chevronPosition === "start" ? `0px ${paddingStart} 0px 0px` : `0px 0px 0px ${paddingEnd}`
        }
    };
};

export const getDrawerHeaderStartSlotStyles = (indentPadding: string): IStackStyles => {

    return {
        root: {
            padding: indentPadding !== "0px" ? `0px 0px 0px ${indentPadding}` : undefined
        }
    };
};
